import { Box, Flex, Link, Text } from '@chakra-ui/react';

export const companyData = {
	name: 'HashUp P.S.A.',
	address: 'al. Jana Pawła 27',
	addressDetails: '00-867 Warszawa',
	email: 'hello@hashup.it',
	NIP: '5272974670',
	KRS: '0000927509',
};

export const CompanyInformation = ({ t, isMobile }: { t: any; isMobile?: boolean }) => {
	return (
		<Flex
			mb="15px"
			fontSize="12px"
			alignItems={isMobile ? 'center' : ''}
			flexDirection="column"
			w="100%"
			mt={{ base: '30px', md: '0' }}
		>
			<Text
				color="#6D6D6D"
				fontWeight="600"
			>
				{t('footer.headings.headquarters').toUpperCase()}
			</Text>
			<Text
				textAlign={isMobile ? 'center' : 'left'}
				p="10px 0"
				maxW="167px"
				fontWeight="600"
				fontSize="14px"
				color="white"
			>
				{companyData.name}
				<br />
				{companyData.address}
				<br />
				{companyData.addressDetails}
			</Text>
			<Text
				textAlign={isMobile ? 'center' : 'left'}
				p="10px 0"
				color="white"
			>
				<Link
					_focus={{ boxShadow: 'none' }}
					href={`mailto:${companyData.email}`}
				>
					{companyData.email}
				</Link>
			</Text>
			<Box
				fontSize="14px"
				fontWeight="400"
				textAlign={isMobile ? 'center' : 'left'}
				p="10px 0"
				color="#6D6D6D"
			>
				<Text>NIP: {companyData.NIP}</Text>
				<Text>KRS: {companyData.KRS}</Text>
			</Box>
		</Flex>
	);
};
